import React, { useState } from "react";
import { Table, Button, Modal, Row, Col } from "react-bootstrap";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import "./ProductTable.css";

const ProductTable = ({
  highlightDelivered,
  repairDetails,
  onDelete,
  onEdit,
}) => {
  const taxableAmount = repairDetails.reduce((sum, item) => {
    const stonePrice = parseFloat(item.stone_price) || 0;
    const makingCharges = parseFloat(item.making_charges) || 0;
    const rateAmt = parseFloat(item.rate_amt) || 0;
    return sum + stonePrice + makingCharges + rateAmt;
  }, 0);
  const taxAmount = repairDetails.reduce(
    (sum, item) => sum + parseFloat(item.tax_amt || 0),
    0
  );
  const netAmount = taxableAmount + taxAmount;

  const [showModal, setShowModal] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);

  const handleView = (detail) => {
    setSelectedDetail(detail);
    setShowModal(true);
  };
  function isCurrentDate(dateString) {
    const today = new Date();
    const date = new Date(dateString);

    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }

  return (
    // <div style={{ maxHeight: "107px", overflowY: "auto", position: "relative" }}>
    <div>
      <Table className="dataTable_headerCell1" bordered hover responsive>
        <thead
          style={{
            position: "sticky",
            top: 0,
            background: "white",
            zIndex: 2,
            fontSize: "13px",
          }}
        >
          <tr>
            <th>S No</th>
            <th>BarCode</th>
            {/* <th>Invoice Number</th> */}
            <th>Product Name</th>
            <th>Metal</th>
            <th>Purity</th>
            <th>Gr Wt</th>
            <th>St Wt</th>
            <th>VA%</th>
            <th>Total Wt</th>
            <th>Rate</th>
            <th>MC</th>
            <th>Discount</th>
            <th>Fest Discount</th>
            <th>Tax %</th>
            <th>Tax Amt</th>
            <th>Total Price</th>
            <th>Image</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {repairDetails.length > 0 ? (
            repairDetails.map((detail, index) => {
              const isToday = isCurrentDate(detail.date);
              return (
                <tr key={index} className="table-values-sales">
                  <td>{index + 1}</td>
                  <td>{detail.code}</td>
                  {/* <td>{detail.invoice_number}</td> */}
                  <td>{detail.product_name || detail.category || ""}</td>
                  <td>{detail.metal_type}</td>
                  {/* <td>{detail.pricing === 'By Weight' ? detail.selling_purity : detail.printing_purity}</td> */}
                  <td>
                    {detail.pricing === "By Weight"
                      ? detail.selling_purity || detail.purity
                      : detail.printing_purity || detail.purity}
                  </td>
                  <td>{detail.gross_weight}</td>
                  <td>{detail.stone_weight}</td>
                  <td>{detail.va_percent}</td>
                  <td>{detail.total_weight_av}</td>
                  <td>
                    {detail.pieace_cost ? detail.pieace_cost : detail.rate}
                  </td>
                  <td>{detail.making_charges}</td>
                  <td>{detail.disscount}</td>
                  <td>{detail.festival_discount}</td>
                  <td>{detail.tax_percent}</td>
                  <td>{detail.tax_amt}</td>
                  <td>{detail.total_price}</td>
                  <td>
                    {detail.imagePreview ? (
                      <img
                        src={detail.imagePreview}
                        alt="Uploaded"
                        style={{ width: "50px", height: "50px" }}
                      />
                    ) : (
                      "No Image"
                    )}
                  </td>
                  <td
                    style={{
                      color:
                        detail.sale_status === "Delivered" ? "green" : "red",
                      backgroundColor:
                        highlightDelivered && detail.sale_status === "Delivered"
                          ? "#f8d7da"
                          : "#ffffff",
                    }}
                  >
                    {detail.sale_status}
                  </td>

                  <td>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <FaEye
                        onClick={() => handleView(detail)}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          color: "green",
                        }}
                      />
                      <FaEdit
                        onClick={() => {
                            onEdit(index);
                            setTimeout(() => onEdit(index), 1);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          color: "blue",
                        }}
                      />
                      <FaTrash
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          color: isToday ? 'red' : 'gray',
                        }}
                        onClick={() => {if (isToday) onDelete(index);}}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="19 " className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
        {repairDetails.length > 0 && (
          <tfoot style={{ fontSize: "12px" }}>
            <tr style={{ fontWeight: "bold", background: "#f8f9fa" }}>
              <td>{repairDetails.length}</td>
              <td colSpan="4"></td>
              <td>
                {repairDetails
                  .reduce(
                    (sum, item) => sum + parseFloat(item.gross_weight || 0),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td>
                {" "}
                {repairDetails
                  .reduce(
                    (sum, item) => sum + parseFloat(item.stone_weight || 0),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td></td>
              <td>
                {repairDetails
                  .reduce(
                    (sum, item) => sum + parseFloat(item.total_weight_av || 0),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td colSpan="10"></td>
            </tr>
          </tfoot>
        )}
      </Table>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Product Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDetail && (
            <Table className="dataTable_headerCell1" bordered hover responsive size="sm" style={{ backgroundColor: '#fff' }}>
              <tbody>
                {(() => {
                  // Define all possible fields with their display names
                  const fields = [
                    { key: 'code', label: 'BarCode' },
                    { key: 'metal_type', label: 'Metal' },
                    { key: 'pricing', label: 'Pricing' },
                    { key: 'weight_bw', label: 'Weight BW' },
                    { key: 'va_percent', label: 'VA%' },
                    { key: 'rate', label: 'Rate' },
                    { key: 'mc_per_gram', label: 'MC %' },
                    { key: 'disscount_percentage', label: 'Discount %' },
                    { key: 'tax_amt', label: 'Tax Amount' },
                    { key: 'category', label: 'Category' },
                    { key: 'design_name', label: 'Design Name' },
                    { key: 'gross_weight', label: 'Gross Weight' },
                    { key: 'stone_price', label: 'Stone Price' },
                    { key: 'wastage_weight', label: 'Wastage Wt' },
                    { key: 'rate_amt', label: 'Metal Amount' },
                    { key: 'making_charges', label: 'Total MC' },
                    { key: 'disscount', label: 'Discount' },
                    { key: 'total_price', label: 'Total Price' },
                    { key: 'product_name', label: 'Sub Category' },
                    { key: 'purity', label: 'Purity' },
                    { key: 'stone_weight', label: 'Stone Weight' },
                    { key: 'va_on', label: 'Wastage on' },
                    { key: 'total_weight_av', label: 'Total Weight' },
                    { key: 'mc_on', label: 'MC On' },
                    { key: 'hm_charges', label: 'HM Charges' },
                    { key: 'tax_percent', label: 'Tax %' },
                    { key: 'remarks', label: 'Remarks' }
                  ];

                  // Filter out fields that don't have data
                  const validFields = fields.filter(field => {
                    const value = selectedDetail[field.key];
                    return value !== null && value !== undefined && value !== '' && value !== '0' && value !== 0 && value !== '0.00' && parseFloat(value) !== 0;
                  });

                  // Create rows with 6 columns each (3 key-value pairs per row)
                  const rows = [];
                  for (let i = 0; i < validFields.length; i += 3) {
                    const rowFields = validFields.slice(i, i + 3);
                    rows.push(rowFields);
                  }

                  return rows.map((rowFields, rowIndex) => (
                    <tr key={rowIndex} className="table-values-sales" style={{ 
                      backgroundColor: rowIndex % 2 === 0 ? '#f8f9fa' : '#fff',
                      borderBottom: '1px solid #e9ecef'
                    }}>
                      {rowFields.map((field, colIndex) => (
                        <React.Fragment key={colIndex}>
                          {/* Key Column */}
                          <td style={{ 
                            width: '16.66%', 
                            padding: '6px 8px', 
                            textAlign: 'left',
                            borderRight: '1px solid #e9ecef',
                            borderBottom: '1px solid #e9ecef',
                            backgroundColor: '#f8f9fa'
                          }}>
                            <div style={{ textAlign: 'left' }}>
                              <strong style={{ 
                                fontSize: '10px', 
                                color: '#6B451E',
                                fontWeight: '600'
                              }}>{field.label}</strong>
                            </div>
                          </td>
                          {/* Value Column */}
                          <td style={{ 
                            width: '16.66%', 
                            padding: '6px 8px', 
                            textAlign: 'left',
                            borderRight: '1px solid #e9ecef',
                            borderBottom: '1px solid #e9ecef'
                          }}>
                            <div style={{ textAlign: 'left' }}>
                              <span style={{ 
                                fontSize: '11px',
                                color: '#495057',
                                fontWeight: '500'
                              }}>{selectedDetail[field.key]}</span>
                            </div>
                          </td>
                        </React.Fragment>
                      ))}
                      {/* Fill remaining columns if row has less than 3 fields */}
                      {rowFields.length < 3 && Array.from({ length: (3 - rowFields.length) * 2 }).map((_, emptyIndex) => (
                        <td key={`empty-${emptyIndex}`} style={{ 
                          width: '16.66%', 
                          padding: '6px 8px',
                          borderRight: '1px solid #e9ecef',
                          borderBottom: '1px solid #e9ecef',
                          backgroundColor: emptyIndex % 2 === 0 ? '#f8f9fa' : '#fff'
                        }}></td>
                      ))}
                    </tr>
                  ));
                })()}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProductTable;
